<i18n src="./translations"></i18n>

<template>
  <PdpTabExpandableContent
    class="pdp-tab-gpsr"
    :headline="$t('pdp-tab-gpsr.headline')"
  >
    <div v-for="[key, item] in Object.entries(gpsr)" :key="key" class="row">
      <p class="title">{{ item.title }}</p>
      <p>{{ item.name }}</p>
      <!-- eslint-disable-next-line vue/no-v-html -->
      <p class="address" v-html="item.address"></p>
      <p>{{ item.description }}</p>
      <p>{{ item.footer }}</p>
    </div>
  </PdpTabExpandableContent>
</template>

<script>
import PdpTabExpandableContent from 'Components/02-molecules/pdp-tab-expandable-content/PdpTabExpandableContent';

export default {
  name: 'PdpVehicleTypesTab',
  components: { PdpTabExpandableContent },
  props: {
    gpsr: {
      type: Object,
      default: () => ({}),
      required: true,
    },
    activeTab: {
      type: Boolean,
      default: false,
    },
    plainTabBase: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
.row {
  margin-bottom: var(--space-3);
  line-height: var(--space-3);

  .title {
    font-weight: bold;
    margin-bottom: var(--space-1);
  }

  .address {
    margin-bottom: var(--space-1);
  }
}
</style>
